import { ServiceRequestCreationNote } from './ServiceRequestFormDetailsCustomHooks/serviceRequestFormtypes';

export interface DetailsHeaderCopy {
  title: string;
  description: string;
}

const NOTE_PREVIEW_MAX_LENGTH: number = 60;

export const ADD_NOTE_CALLOUT_TITLE: string =
  'Add a note to this request (optional)';

export const ADD_NOTE_CALLOUT_SUBTITLE: string =
  "Include extra details on submission — for example an alternate on-site contact, like a partner or occupant who'll be home for the visit. Your note appears on the request after it's created.";

export const ADD_NOTE_FORM_CALLOUT_TITLE: string = 'What to put in your note';

export const ADD_NOTE_FORM_CALLOUT_SUBTITLE: string =
  'It\'s common to add contact details for whoever will be on-site if it isn\'t you — a partner, tenant, or occupant — so the team knows who to reach. Give the note a descriptive subject (e.g. "On-site contact") so it\'s easy to find later.';

export const buildNotePreviewText = (
  note: ServiceRequestCreationNote
): string => {
  const trimmedTitle: string = note.title?.trim() ?? '';

  if (trimmedTitle.length > 0) {
    return trimmedTitle;
  }

  const strippedBody: string = note.body.replace(/<[^>]*>/g, '').trim();

  if (strippedBody.length === 0) {
    return 'Note';
  }

  if (strippedBody.length > NOTE_PREVIEW_MAX_LENGTH) {
    return `${strippedBody.slice(0, NOTE_PREVIEW_MAX_LENGTH)}…`;
  }

  return strippedBody;
};

export const getHeaderCopy = (
  isAnnotating: boolean,
  isAddingNote: boolean,
  isEditingNote: boolean,
  serviceRequestLabel: string
): DetailsHeaderCopy => {
  if (isAnnotating) {
    return {
      title: 'Annotate Images',
      description:
        'Tap an image to draw on it, then head back to finish your request.',
    };
  }

  if (isAddingNote) {
    return {
      title: isEditingNote ? 'Edit Note' : 'Add Note',
      description:
        'Add a subject and details for your note, then head back to finish your request.',
    };
  }

  return {
    title: `Submit ${serviceRequestLabel}`,
    description:
      "Include details about what's happening and we'll get back to you to confirm a service time.",
  };
};
